import { render } from "./TopNavigationItem.vue?vue&type=template&id=0edad819&scoped=true"
import script from "./TopNavigationItem.vue?vue&type=script&lang=ts"
export * from "./TopNavigationItem.vue?vue&type=script&lang=ts"

import "./TopNavigationItem.vue?vue&type=style&index=0&id=0edad819&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0edad819"

export default script